<template>
    <v-app id="inspire">
        <AdminHeader type="search" />
        <v-main class="grey lighten-3">
            <v-container>
                <v-row>
                    <AdminMenu />
                    <v-container class="col-10">
                        <v-row>
                            <v-col class="page-top d-flex justify-space-between" cols="12">
                                <div>
                                    <div class="page-title">Персонал</div>
                                    <div class="breadcrumb">Персонал</div>
                                </div>
                            </v-col>
                        </v-row>
                        <Grid :column="4" :gap="20" :customStyle="{ alignItems: 'flex-start' }">
                            <Block :padding="0" :withBorder="true" :overflowHidden="true">
                                <div class="column">
                                    <div class="column__item heading">
                                        Учёт рабочего времени
                                    </div>
                                    <div class="column__item">
                                        Табеля учёта рабочего времени
                                    </div>
                                    <div class="column__item">
                                       Гарфик работы
                                    </div>
                                    <div class="column__item">
                                       Гарфик дежурств
                                    </div>
                                </div>
                            </Block>
                            <Block :padding="0" :withBorder="true" :overflowHidden="true">
                                <div class="column">
                                    <div class="column__item heading">
                                        Расчёт зарплаты
                                    </div>
                                    <div class="column__item">
                                        Начисление зарплаты
                                    </div>
                                </div>
                            </Block>
                        </Grid>
                    </v-container>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
import { globalMethods } from "@/mixins/globalMethods";
import AdminHeader from '@/components/Admin/AdminHeader.vue';
import AdminMenu from '@/components/Admin/AdminMenu.vue';
export default {
    name: 'AdminStaff',
    mixins: [globalMethods],
    components: {
        AdminHeader,
        AdminMenu,
    },
    data() {
        return {
            pageSelect: 1,
            pageShow: [1, 2, 3, 4],
            maxPage: 24,
            select: null,
            dialogClient:false,
            showFilterGrid: false,
            rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        }
    }
}
</script>
<style scoped lang="scss">
.page-top {
    margin-bottom: 20px;
}

.column {
    &__item {
        padding: 12px 15px;
        color: #1A1A1A;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        background: #fff;

        &:not(:last-child) {
            border-bottom: 1px solid #E0E0E0;
        }

        &.heading {
            padding: 20px 15px;
            background: #F1F1F1;
            font-size: 16px;
            line-height: 24px;
        }
    }
}
.no-bg {
    background-color: transparent !important;
}
.filtere {
    padding: 20px;

    .top-line {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            flex: 1;
            display: flex;
            align-items: center;

            .v-input__slot {
                border-radius: 12px;
            }
        }

        .right {
            .v-input__slot {
                border-radius: 12px;
            }

            .toggle-label {
                display: block;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                text-align: right;
                width: 100%;
                color: #767676;
            }

            .v-btn-toggle {
                button {
                    &:first-child {
                        border-radius: 12px 0 0 12px;
                    }

                    &:last-child {
                        border-radius: 0 12px 12px 0;
                    }

                    background: #fff !important;

                    &::before {
                        display: none;
                    }
                }
            }
        }

        .w-352 {
            width: 352px;
        }

        .filter-btn {
            background: #A13453;
            border-radius: 12px;
            text-transform: none;
            color: #FFFFFF;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            box-shadow: none;
            padding: 13px 21px;

            svg {
                margin-right: 5px;
            }
        }

    }

    .hidden-block {
        padding-top: 20px;

    }

    &__field {
        &.colspan-4 {
            grid-column: 1 / 5;
        }

        &.button-block {
            button {
                &:not(:last-child) {
                    margin-right: 20px;
                }
            }
        }

        .label {
            color: #1A1A1A;
            display: block;
            margin-bottom: 8px;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
        }
    }

    button {
        border-radius: 12px;
        text-transform: none;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        box-shadow: none;
        padding: 13px 21px;

        &.apply {
            background: #629F33 !important;
            color: #fff !important;
        }

        &.clear {
            background: #F1F1F1 !important;
            color: #1A1A1A !important;
        }

    }
}

.min-w-173 {
    min-width: 173px;
}

.cliente {
    display: flex;
    align-items: center;

    .ava {
        margin-right: 8px;
    }
}

.navigete {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .information {
        font-family: 'Circe';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: #767676;
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        ul {
            list-style: none;
            display: flex;
            align-items: center;
            margin-right: 29px;

            &.list-end {
                li {
                    &.etc {
                        order: 1;
                    }
                }
            }

            li {
                &:not(:last-child) {
                    margin-right: 29px;
                }

                &:nth-child(1) {
                    order: 1;
                }

                &:nth-child(2) {
                    order: 2;
                }

                &:nth-child(3) {
                    order: 3;
                }

                &:nth-child(4) {
                    order: 4;
                }

                &.etc {
                    order: 5;
                    -webkit-touch-callout: none;
                    /* iOS Safari */
                    -webkit-user-select: none;
                    -khtml-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }

                &:nth-child(6) {
                    order: 6
                }

                .pagination-btn {
                    width: 32px !important;
                    max-width: 32px !important;
                    min-width: 32px !important;
                    height: 32px !important;
                    max-height: 32px !important;
                    min-height: 32px !important;
                    background: #fff !important;
                    box-shadow: none !important;
                    font-family: 'Circe';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 13px;
                    line-height: 16px;
                    color: #629F33 !important;
                    border-radius: 50%;

                    &.active {
                        color: #fff !important;
                        background: #629F33 !important;
                    }
                }
            }

        }

        .pagination-btn-icon {
            width: 24px !important;
            max-width: 24px !important;
            min-width: 24px !important;
            height: 24px !important;
            max-height: 24px !important;
            min-height: 24px !important;
            background: #fff !important;
            box-shadow: none !important;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 700;
            font-size: 13px;
            line-height: 16px;
            color: #629F33 !important;
            border-radius: 50%;

            &.left {
                -moz-transform: scale(-1, -1);
                -o-transform: scale(-1, -1);
                -webkit-transform: scale(-1, -1);
                transform: scale(-1, -1);
            }

        }
    }
}
</style>